import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-i-no-results',
  templateUrl: './i-no-results.component.html',
  styleUrls: ['./i-no-results.component.scss'],
})
export class INoResultsComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
